import React from 'react'
import Popup from '../../Components/Popup';

export default function Imagepopup({ lgShow, setLgShow, PreviewImg }) {
    return (
        <Popup isshow={lgShow} size={"lg"} title={"Preview Image"}
            closePopup={(e) => { setLgShow(false) }}
            modalBody={<img src={PreviewImg} height={200} />} visibleSaveBtn={false} />
    )
}
